import { BUSINESS_SUBTYPES } from "@/constants";

export * from "./schema";
export * from "./routes";
export * from "./api";

export const getBusinessSubTypeLabel = (type) => {
  for (const category of BUSINESS_SUBTYPES) {
    for (const subcategory of category.subcategories) {
      if (subcategory.type === type) {
        return subcategory.label;
      }
    }
  }
  return undefined;
};
